// extracted by mini-css-extract-plugin
export default {"tablet":"Banner-module--tablet--SMNxX","retina":"Banner-module--retina--DReaG"};